import React, { useEffect, useState } from 'react'
import { SimpleGrid, Container, VStack, Text } from "@chakra-ui/react";
import { useProduct } from '../../providers/ProductProvider';
import ProductCard from '../common/ProductCard';
import ReactGA from 'react-ga4';
import { useLocation } from 'react-router-dom';

export default function ProductsSearch() {

    const { getProductBySearch } = useProduct();

    const state = useLocation();

    console.log(state);

    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        getProductBySearch(state.state.search).then((data) => {
            console.log(data);
            setProducts(data);
            setLoading(false);
        });
    }, [state.state.search]);

    ReactGA.send({
        hitType: 'pageview',
        page: "/products-search",
        title: "Products Search",
    });

    return (
        <>
            {!loading ? (
                <Container maxW='8xl'>
                    <VStack w='100%' spacing='4' py={4}>

                        <SimpleGrid w='100%' columns={[2, 2, 3, 5]} spacing={[4, 4, 6, 8]}>
                            {products.map((p, index) => {
                                return <ProductCard key={index} item={p} />
                            })}

                        </SimpleGrid>
                    </VStack>
                </Container >
            ) :
                <>
                    {products.length == 0 && !loading ? (
                        <Container maxW='8xl'>
                            <VStack w='100%' spacing='4' py={4}>
                                <Text>No products found</Text>
                            </VStack>
                        </Container>
                    ) : (
                        <Container maxW='8xl'>
                            <VStack w='100%' spacing='4' py={4}>
                                <Text>Loading...</Text>
                            </VStack>
                        </Container>
                    )
                    }
                </>
            }
        </>
    )
}